<template>
  <div class="Badges">
    <main-badges
      v-if="last_unlocked && last_unlocked.length"
      :badges="last_unlocked"
      :customClass="userIsAParent ? 'bg-main' : ''"
    />
    <section id="lockedBadges" class="locked-badgess w-100 p 20 mb-2">
      <badge-achieve :badges="next_to_unlock" :direction="'row'" />
    </section>
  </div>
</template>
<script>
import badgeAchieve from '@/components/badges/badgeAchieve.vue';
import mainBadges from '@/components/badges/mainBadges.vue';

import { mapGetters } from 'vuex';
import store from '@/store';
export default {
  components: {
    badgeAchieve,
    mainBadges,
  },
  computed: {
    ...mapGetters('user', ['getUserName', 'userIsAParent']),
    ...mapGetters('badges', ['getLockedBadges', 'getUnlockedBadges']),
    last_unlocked() {
      return [...(this.getUnlockedBadges || [])];
    },
    next_to_unlock() {
      return [
        ...(this.getLockedBadges.progressive_badges || []),
        ...(this.getLockedBadges.skill_badges || []),
      ];
    },
  },
  beforeRouteEnter(to, from, next) {
    let userId = store.getters['user/getUserId'];
    let promiseEvents = [];
    if (store.getters['user/userIsAParent']) {
      promiseEvents = [
        store.dispatch('badges/FetchParentLockedBadges', userId),
        store.dispatch('badges/FetchParentUnlockedBadges', userId),
      ];
    } else {
      promiseEvents = [
        store.dispatch('badges/FetchChildLockedBadges', userId),
        store.dispatch('badges/FetchChildUnlockedBadges', userId),
      ];
    }
    Promise.all(promiseEvents).then(() => {
      next();
    });
  },
};
</script>
